import { TGetAddressCodeOutputDto } from "@/api/services/global/constant/dtos/get-adress-codes.dto";
import { TGetProvincesAndMunicipalitiesResDto } from "@/api/services/global/constant/dtos/get-provinces-municipalities.dto";
import { globalApi } from "@/utils/api";
import { createUrlWithParams } from "@/utils/url";

export const fetchPrefectureAndMunicipalityByZipCodeApi = async (zipCode: string): Promise<TGetProvincesAndMunicipalitiesResDto> => {
  const url = createUrlWithParams("/prefecture-and-municipality-by-zipcode", { zipCode });
  const rs = await globalApi.get(url);
  return rs.data.data;
};

export const fetchAddressCodesApi = async (): Promise<TGetAddressCodeOutputDto[]> => {
  const rs = await globalApi.get("/address-codes");
  return rs.data.data;
};
